/**
 * Commerce7 Collection Filter - clear filter handle
 */

export default function C7Product() {

	const selectors = {
        productDetail: ".c7-product--details, .c7-bundle--details"
	};

	this.init = () => {
        const target = document.getElementById("c7-content");

        if (target) {
            new MutationObserver((_, observer) => {
                const productDetail = document.querySelector(selectors.productDetail);
                if (productDetail) {
                    renderWinemakerVideo();
                    renderBundleItems();
                    controlWinemakerVideo();
                    stickyAddToCart();
                    addClubPricing();
                    observer.disconnect();
                }
            }).observe(target, { childList: true, subtree: true });
        }
	};

    /**
     * Sticky Add To Cart Bar
     */
    const stickyAddToCart = () => {
        jQuery(document).on('scroll', function() {
            if (jQuery('.c7-product--details .c7-product__add-to-cart').length) {
                if ( jQuery(this).scrollTop() >= jQuery('.c7-product--details .c7-product__add-to-cart').position().top ) {
                    jQuery( '.c7-product--sticky' ).removeClass('d-none');
                }
                else{
                    jQuery( '.c7-product--sticky' ).addClass('d-none');
                }
            }
            if (jQuery('.c7-bundle--details .c7-product__add-to-cart').length) {
                if ( jQuery(this).scrollTop() >= jQuery('.c7-bundle--details .c7-product__add-to-cart').position().top ) {
                    jQuery( '.c7-product--sticky' ).removeClass('d-none');
                }
                else{
                    jQuery( '.c7-product--sticky' ).addClass('d-none');
                }
            }
        });
	}

    /**
     * Render Winemaker Video
     */
    const renderWinemakerVideo = () => {
        if (jQuery('.c7-product--winemaker-video--link').length <= 0) return;

        jQuery('.c7-product--video-button').show();

        const videoLink = jQuery('.c7-product--winemaker-video--link').data('link');
        if (videoLink.includes('youtube')) {
            const videoId = get_youtube_id_from_url(videoLink);
            const html = '<iframe class="youtube-video" src="https://www.youtube.com/embed/' + videoId + '&modestbranding=1&autohide=1&controls=0&rel=0&loop=1&enablejsapi=1&disablekb=1&playlist=' + videoId + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
            jQuery('.c7-product--winemaker-photo').append(html);
        } else if (videoLink.includes('vimeo')) {
            const videoId = get_vimeo_id_from_url(videoLink);
            const html = '<iframe class="vimeo-video" src="https://player.vimeo.com/video/' + videoId + '?enablejs=1&loop=1&controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
            jQuery('.c7-product--winemaker-photo').append(html);
        } else {
            console.log('unkown video type');
            return;
        }
    }

    /**
	 * Get Youtube Video ID from url.
	 *
	 * @param String url Youtube Link.
	 */
	const get_youtube_id_from_url = ( url ) => {
		const regex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const segements = regex.exec(url);
		return segements[7];
	}

    /**
	 * Get Vimeo ID from video link.
	 *
	 * @param String url Vimeo video link.
	 */
	const get_vimeo_id_from_url = ( url ) => {
        const regex = /player\.vimeo\.com\/video\/(\d+)/;
        const segements = regex.exec(url);
        return segements[1];
	}

    /**
     * Control Winemaker Video
     */
    const controlWinemakerVideo = () => {
        jQuery(".c7-product--video-button").on("click", function() {
            if (jQuery(this).hasClass("pause-button")) {
                jQuery(this).removeClass("pause-button")
                jQuery(this).addClass("play-button")
                if (jQuery(this).siblings(".youtube-video").length) {
                    jQuery(this).siblings(".youtube-video").each(function() {
                        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
                    });
                } else if (jQuery(this).siblings(".vimeo-video").length) {
                    jQuery(this).siblings(".vimeo-video").each(function() {
                        this.contentWindow.postMessage('{"method":"pause"}', '*')
                    });
                }
            } else if (jQuery(this).hasClass("play-button")) {
                jQuery('.c7-product--winemaker-photo iframe').show();
                jQuery(".c7-product--winemaker-photo img").hide();
                jQuery(this).removeClass("play-button")
                jQuery(this).addClass("pause-button")
                if (jQuery(this).siblings(".youtube-video").length) {
                    jQuery(this).siblings(".youtube-video").each(function(){
                        this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                    });
                } else if (jQuery(this).siblings(".vimeo-video").length) {
                    jQuery(this).siblings(".vimeo-video").each(function(){
                        this.contentWindow.postMessage('{"method":"play"}', '*')
                    });
                }
            }
        });
    }

    /**
	 * Render items of the bundle
	 */
	const renderBundleItems = () => {
		if (jQuery(".c7-bundle--products").length === 0) {
			return;
		}
        const id = jQuery(".c7-product__add-to-cart__form__quantity input").attr("id").replace("c7-quantity-", "");
        jQuery.ajax({
            type: "GET",
            url: theme_object.ajax_url,
            data: { action: "get_bundle_items", id },
            success: function (response) {
                if (response["success"]) {
                    jQuery(".c7-bundle--products").html(response['content']);
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
	};

    /**
     * Render Club Pricing
     */
    const addClubPricing = () => {
        if ( jQuery(".c7-product--club-pricing").length <= 0 ) return;

        jQuery(".c7-product__add-to-cart__price").append(jQuery(".c7-product--club-pricing"));
    }

    /**
     * Add Customer to Waitlist
     */
    const addCustomerToWaitlist = (event) => {
        const email = event.target.previousElementSibling.value;
        const title = event.target.dataset.title;

        jQuery(".c7-customer-waitlist--notification").html('');

        jQuery.ajax({
            type: "GET",
            url: theme_object.ajax_url,
            data: { action: "add_to_waitlist", email, title },
            success: function (response) {
                if (response['success']) {
                    jQuery(".c7-customer-waitlist").hide();
                }
                jQuery(".c7-customer-waitlist--notification").html(response['notification']);
            }
        })
    }
}
